import { render } from "./BannerCarousel.vue?vue&type=template&id=fa07493a&scoped=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&lang=js"

import "./BannerCarousel.vue?vue&type=style&index=0&id=fa07493a&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa07493a"]])

export default __exports__